import * as React from 'react';

var useWithAbort = function useWithAbort(promiseCreator) {
  var aborted = React.useRef(false);
  var promiseWithAbort = function promiseWithAbort() {
    return (
      // eslint-disable-next-line compat/compat
      new Promise(function (resolve, reject) {
        var promise = promiseCreator();
        promise.then(function (value) {
          if (!aborted.current) {
            resolve(value);
            return;
          }
          reject(new Error('Aborted'));
        }, function (error) {
          return reject(error);
        });
      })
    );
  };
  return {
    start: promiseWithAbort,
    abort: function abort() {
      aborted.current = true;
    }
  };
};

export { useWithAbort };
//# sourceMappingURL=useWithAbort.js.map
